import { Button } from "@/components/ui/button";

export default function ProductTableFooter({
    table,
    selectedProducts,
    totalCount,
    lastSync,
}: {
    table: any;
    selectedProducts: any;
    totalCount: number;
    lastSync: string | null;
}) {
    return (
        <>
            <div className="text-sm text-muted-foreground">
                {selectedProducts.length} of {totalCount.toLocaleString()}{" "}
                row(s) selected.
            </div>

            <div className="text-sm text-muted-foreground text-center">
                Last synced:{" "}
                {lastSync ? new Date(lastSync).toLocaleString() : "Never"}
            </div>

            <div className="flex items-center gap-2">
                <div className="flex items-center gap-1 mr-2">
                    <p className="text-sm text-muted-foreground">
                        Rows per page
                    </p>
                    <select
                        value={table.getState().pagination.pageSize}
                        onChange={(e) => {
                            table.setPageSize(Number(e.target.value));
                        }}
                        className="h-8 w-[70px] rounded-md border border-input bg-background px-2 py-1 text-sm shadow-sm outline-none focus:ring-1 focus:ring-ring"
                    >
                        {[8, 16, 32, 48, 64].map((pageSize) => (
                            <option key={pageSize} value={pageSize}>
                                {pageSize}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="flex items-center gap-2">
                    <span className="text-sm text-muted-foreground">
                        Page {table.getState().pagination.pageIndex + 1} of{" "}
                        {table.getPageCount().toLocaleString()}
                    </span>
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={() => table.previousPage()}
                        disabled={!table.getCanPreviousPage()}
                    >
                        Previous
                    </Button>
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={() => table.nextPage()}
                        disabled={!table.getCanNextPage()}
                    >
                        Next
                    </Button>
                </div>
            </div>
        </>
    );
}
